import {CardPanel} from "../../../stemjs/src/ui/CardPanel.jsx";
import {UI} from "../../../stemjs/src/ui/UIBase.js";
import {ContestStore} from "../../../contest/js/state/ContestStore.js";
import {Link} from "../../../stemjs/src/ui/primitives/Link.jsx";
import {ContestTimeCounter} from "../../../contest/js/ContestTimeCounter.jsx";

export class UpcomingContestsPanel extends CardPanel {
    getTitle() {
        return UI.T("Upcoming Contests");
    }

    render() {
        const contests = ContestStore.all().filter(contest => (!contest.systemGenerated && !contest.hasFinished() && !contest.isInfinite()));
        let list = [];
        if (contests.length) {
            let startedContests = contests.filter(contest => contest.hasStarted());
            let futureContests = contests.filter(contest => !contest.hasStarted());
            startedContests = startedContests.sort((contest1, contest2) => {
                return -contest2.getEndTime() + contest1.getEndTime();
            });
            futureContests = futureContests.sort((contest1, contest2) => {
                return -contest2.getStartTime() + contest1.getStartTime();
            });
            list = startedContests
                .concat(futureContests)
                .map(contest => <div style={{border: "2px  #ddd", borderRadius: "8px", textAlign: "center", margin: "1px"}}>
                        <div style={{
                            fontSize: "1.3em",
                        }}>
                            <Link href={"/contest/" + contest.name} value={contest.longName}/>
                        </div>
                        <div style={{
                            fontSize: "1em",
                            paddingTop: "8px",
                        }}>
                            {contest.getFormattedStartTime()}
                        </div>
                        <div style={{
                            fontSize: "1em",
                            paddingTop: "8px",
                            fontWeight: "bold",
                            fontStyle: "italic",
                        }}>
                            <ContestTimeCounter contest={contest}/>
                        </div>
                    </div>
                );
        } else {
            list.push(<div style={{textAlign: "center"}}>{UI.T("No upcoming contests.")}</div>);
        }
        return <div style={{padding: "8px"}}>
            {list}
            <div style={{textAlign: "center", paddingTop: "8px",}}>
                <Link href={"/contests/"} value={UI.T("See full contests list")}/>
            </div>
        </div>;
    }
}